import React from 'react'

export type PageSectionProps = {
  children: React.ReactNode
}

export const PageSection: React.FC<PageSectionProps> = ({ children }) => {
  return <section className="py-6">{children}</section>
}
